<template>
    <span class="badge" :class="getLevelClass" :style="'font-size:' + fontSize">
        {{ getDisplayLabel }}
    </span>
</template>

<script>
export default {
    name: "GymVideoLevelBadge",
    props: {
        level: {
            type: Number,
            required: true
        },
        label: {
            type: String,
            default: null
        },
        fontSize: {
            type: String,
            default: '14px'
        }
    },
    computed: {
        getDisplayLabel() {
            if(this.label !== null)
                return this.label;

            return this.level;
        },
        getLevelClass() {
            switch (this.level) {
                case 1: // Fundamental
                    return 'badge-dark text-primary';
                case 2: // Challenge
                    return 'badge-dark text-warning';
                case 3: // Advanced
                    return 'badge-dark text-danger';
            }
        },
    }
}
</script>

<style scoped>

</style>
